import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import {
    EMAIL_TO_MESSAGE_STATUS_MAPPER, IScheduledEmailDTO, ScheduledEmailStatus, ScheduledTypes
} from '../../../../../../../api/scheduled-email.dao';
import { getFormattedTimezoneOffsetByTimezone } from '../../../../../../../infrastructure/utils/date-fns-overrides.utils';
import { getScheduledEmailDateString, getScheduledEmailTimeString } from '../../../../../../../infrastructure/utils/date.util';
import DefaultButton from '../../../../../../global/default-button/default-button';
import Text from '../../../../../../global/text/text';
import { REMOVE_TEXT } from '../../../../../../../constants/common-labels.constants';
import './scheduled-email-item.scss';
import { observer } from 'mobx-react';
interface IProps {
    email: IScheduledEmailDTO;
    timeZone: string;
    onRemove: (id: string, type: ScheduledTypes) => void;
    onEdit: (id: string, type: ScheduledTypes) => void;
    isSelected: boolean;
    type: ScheduledTypes;
}

const ScheduledEmailItem = observer((props: IProps) => {
    const { email, timeZone, isSelected, onRemove, onEdit, type } = props;

    const formattedTimezoneOffset = useMemo(() => {
        return getFormattedTimezoneOffsetByTimezone(timeZone);
    }, [timeZone, getFormattedTimezoneOffsetByTimezone]);

    return (
        <div key={email.id} className={classNames(
            'scheduled-email-item',
            { 'scheduled-email-item--selected': isSelected }
        )}>
            <div className='scheduled-email-item__header'>
                <Text className='scheduled-email-item__title' message={email.name} withEllipsis />
                <DefaultButton className='scheduled-email-item__button'
                    text={
                        <FormattedMessage
                            id='oe.websiteTab.configureEmail'
                            description='Button label'
                            defaultMessage='Configure Email'
                        />
                    }
                    modifier={['fat', 'confirm-safe']}
                    onClick={() => onEdit(email.id, type)}
                    disabled={email.status !== ScheduledEmailStatus.SCHEDULED}
                />
            </div>
            <div className='scheduled-email-item__content'>
                <div className='scheduled-email-item__date-and-time'>
                    <div className='flex'>
                        <div className='scheduled-email-item__time'>
                            {getScheduledEmailTimeString(email.dateTime, timeZone)}
                        </div>
                        <div className='scheduled-email-item__timezone'>
                            {formattedTimezoneOffset}
                        </div>
                    </div>
                    <div className='scheduled-email-item__date'>
                        {getScheduledEmailDateString(email.dateTime, timeZone)}
                    </div>
                </div>
                {email.status !== ScheduledEmailStatus.SCHEDULED &&
                    <div className='scheduled-email-item__number-of-recipients'>
                        <FormattedMessage
                            id='oe.common.emailStatus'
                            description='Status label'
                            defaultMessage={EMAIL_TO_MESSAGE_STATUS_MAPPER[email.status]}
                        />
                        {(email.status === ScheduledEmailStatus.SUCCEEDED || email.status === ScheduledEmailStatus.IN_PROGRESS) &&
                            <Text message={`${email.messagesStats?.sentMessagesNumber ?? 0} Recipients`} />
                        }
                    </div>
                }
                {email.status === ScheduledEmailStatus.SCHEDULED &&
                    <DefaultButton
                        text={<FormattedMessage {...REMOVE_TEXT} />}
                        modifier='link-warn'
                        onClick={() => onRemove(email.id, type)}
                        className='scheduled-email-item__remove-item-button'
                    />
                }
            </div>
        </div>
    );
});

export default ScheduledEmailItem;
